













import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { PropType } from 'vue';
import { EstimatedType } from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';

const name = 'ttam-audience-size-flex-estimate-num';
export default defineComponent({
  props: {
    estimateType: {
      type: Number as PropType<EstimatedType>,
    },
    estimateCount: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const { estimateType } = toRefs(props);

    const label = computed(() => {
      const labelEnums = {
        [EstimatedType.TOO_NARROW]: i18n.t('audience_estimate_gear_too_narrow'),
        [EstimatedType.NARROW]: i18n.t('audience_estimate_gear_narrow'),
        [EstimatedType.BALANCED]: i18n.t('audience_estimate_gear_balanced'),
        [EstimatedType.FAIRLY_BROAD]: i18n.t('audience_estimate_gear_fairly_broad'),
        [EstimatedType.BROAD]: i18n.t('audience_estimate_gear_broad'),
      };
      return labelEnums[estimateType.value] ?? '';
    });

    const labelStyleConfig = {
      [EstimatedType.TOO_NARROW]: { color: '#f60457', background: '#feedef' },
      [EstimatedType.NARROW]: { color: '#3451f7', background: '#e8efff' },
      [EstimatedType.BALANCED]: { color: '#3451f7', background: '#e8efff' },
      [EstimatedType.FAIRLY_BROAD]: { color: '#0ac0b9', background: '#d9fefc' },
      [EstimatedType.BROAD]: { color: '#0ac0b9', background: '#d9fefc' },
    };
    const labelStyle = computed(() => labelStyleConfig[estimateType.value] ?? {});

    const retry = () => {
      emit('retry');
    };

    return {
      name,
      label,
      labelStyle,
      retry,
    };
  },
});
